<template>
  <v-main class="position-relative">
    <div ref="viewContainer" class="px-6 view-container" :class="{ 'narrow-content': isNarrow }">
      <core-toolbar v-if="showCoreToolbar" />
      <div class="px-0 py-6">
        <router-view />
      </div>
    </div>
    <opinew-app-store-review-request-modal v-if="accountInfo.uiShowRequestShopifyReviewModal" />
  </v-main>
</template>

<script>
import Toolbar from '@/components/core/Toolbar';
import OpinewAppStoreReviewRequestModal from '@/components/core/OpinewAppStoreReviewRequestModal';
import { mapState } from 'vuex';

export default {
  name: 'MainView',
  components: {
    OpinewAppStoreReviewRequestModal,
    CoreToolbar: Toolbar,
  },
  metaInfo() {
    return {
      title: 'Opinew Admin',
    };
  },
  computed: {
    ...mapState(['accountInfo']),

    isNarrow() {
      return ['/overview', '/analytics', '/general-settings'].some(p => this.routePath.includes(p));
    },

    routePath() {
      const { path } = this.$route;
      const routePath =
        path && path.length > 1
          ? path
          : // acquire view path before router is ready preventing layout shifts
            window.location.href
              .replace(window.location.origin, '')
              .replace(/^\/(#|dashboard)/i, '')
              .toLowerCase();

      return routePath;
    },

    showCoreToolbar() {
      return !['/welcome', '/first-steps', '/auth'].some(p => this.routePath.includes(p));
    },
  },
};
</script>

<style lang="scss">
#app.v-application {
  background-color: var(--v-black_lighten3-base);
}

#app.v-application .ptext.info {
  background-color: transparent !important;
}

.v-main {
  .v-main__wrap {
    background-color: var(--v-black_lighten3-base);
    //height: 100%;
  }
}

.view-container {
  max-width: 1300px;
  margin: auto;
}

.main-view {
  min-height: calc(100vh - 70px);
  background-color: var(--v-black_lighten3-base);
}

.narrow-content {
  max-width: 1000px !important;
  margin: auto;
  width: 100%;
  //padding-left: 4rem !important;
  //padding-right: 4rem !important;
  //transition: none !important;

  &.normal-content {
    max-width: 1200px !important;
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }
}

.main-view-gs {
  height: auto !important;
  background-color: var(--v-black_lighten3-base);
}

.integrations-block {
  display: block !important;
}

.w-100 {
  width: 100%;
}
</style>
